import React, { useEffect, useCallback, useRef } from "react";
import cssClasses from "./Transactions.module.css";
import DropDown from "../../Subcomponents/DropDown";
import { useState } from "react";
import DateComponent from "../../Subcomponents/DateComponent";
import SearchBar from "../../Subcomponents/Search";
import { debounce } from "lodash";
import EmptyState from "../../Assets/Images/Common/noProjectFound.svg";
import { DataGrid } from "@mui/x-data-grid";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { errorTost, infoTost } from "../../Services/Toast";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import { getAllTransactions } from "../../Services/Transactions";
import { useSelector } from "react-redux";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import { supabase } from "../../supabaseClient";
import { Card } from "@mui/material";
import Button from "../../Subcomponents/Button";
import InfiniteScroll from "react-infinite-scroll-component";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";

const dataGridStyles = {
	"&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
		outline: "none",
	},
	border: "1px solid #EAECF0 !important",
	fontWeight: "400",
	fontSize: "1.4rem",
	lineHeight: "2rem",
	color: "#667085",
	fontFamily: "Inter-Medium",
	borderRadius: "8px",
	'& div[data-colindex="1"]': {
		color: "#101828",
		fontWeight: "500",
	},
	"& .MuiDataGrid-virtualScrollerRenderZone": {
		"& .MuiDataGrid-row": {
			borderBottom: "1px solid #EAECF0",
			background: "#FFFFFF",
			/* Shadow/xl */

			// boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
			borderRadius: "1rem",

			//   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
			//   backgroundColor: "#FFFFFF",
		},
		"& .MuiDataGrid-row.Mui-selected:hover": {
			borderBottom: "1px solid #EAECF0",
			backgroundColor: "#FFFFFF",
			// "&:nth-of-type(2n+1)": {
			//   backgroundColor: "rgba(249, 250, 251, 1)",
			// },
		},
	},
	"& .MuiDataGrid-iconSeparator ": {
		display: "none",
	},
	"& .MuiDataGrid-columnHeader:hover": {
		"& .MuiDataGrid-menuIcon": {
			visibility: "hidden",
		},
	},
	"& .MuiDataGrid-columnHeaders + div": {
		height: "calc(100vh - 31.5rem) !important",
	},
	"&  .MuiDataGrid-columnHeaders": {
		background: "#F9FAFB",
		/* Gray/200 */
		border: "1px solid #EAECF0",
		/* Shadow/xl */
		// boxShadow:
		//   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
		// borderRadius: "8px",

		marginBottom: "1rem",
		borderBottom: "6px solid #EAECF0",
	},
	"& .MuiDataGrid-columnSeparator": {
		display: "none",
	},
	"& .MuiDataGrid-checkboxInput": {
		"& svg": {
			width: "2rem",
			height: "2rem",
			background: "#FFFFFF",
		},
	},
	// "& .MuiTablePagination-displayedRows": {
	//   display: "none",
	// },
	"& .MuiDataGrid-footerContainer": {
		"& .MuiTablePagination-displayedRows ": {
			display: "none",
		},
		"& .MuiDataGrid-selectedRowCount": {
			visibility: "hidden ",
		},
	},
	"&  [title='Sort']": {
		//visibility:"hidden",
		display: "none",
		cursor: "none",
	},
	"& [title='Go to previous page']": {
		// borderRadius: "0",
		border: "1px solid #EAECF0",
		borderRadius: "0.8rem",
		marginRight: "0.5rem",
	},
	"& [title='Go to next page']": {
		// borderRadius: "0",
		border: "1px solid #EAECF0",
		borderRadius: "0.8rem",
		marginRight: "0.5rem",
	},
	"& [title='Go to previous page']:after": {
		content: "'Previous'",
		marginLeft: "1rem",
	},
	"& [title='Go to next page']:before": {
		content: "'Next'",
		marginRight: "1rem",
	},
	"& .MuiDataGrid-columnHeader": {
		padding: "0 4rem",

		"&:focus": {
			outline: "none",
		},
	},
	"&  .MuiDataGrid-row ": {
		maxHeight: "7.2rem !important",
		minHeight: "7.2rem !important",
	},
	"& .MuiDataGrid-cell": {
		padding: "0 4rem",
		minHeight: "7.2rem !important",
		maxHeight: "7.2rem !important",
		"&:focus": {
			outline: "none",
		},
	},
	"& .MuiButtonBase-root": {
		fontSize: "1.6rem",
	},
	"& .MuiDataGrid-cell:focus-within": {
		outline: "none !important",
	},
	"& .MuiDataGrid-cell": {
		padding: "0 2rem",
		minHeight: "7.2rem !important",
		maxHeight: "7.2rem !important",

		"&:focus": {
			outline: "none",
		},
	},
	"& .MuiDataGrid-columnHeader": {
		padding: "0 2rem",

		"&:focus": {
			outline: "none",
		},
	},
};

const Transactions = () => {
	const dispatch = useDispatch();
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	const filterBy = useRef("Latest First");
	const [selectDates, setSelectDates] = useState([
		{ label: "StartDate", value: "" },
		{ label: "EndDate", value: "" },
	]);
	const [isEndDateNotNull, setIsEndDateNotNull] = useState(false);
	const [helperText, setHelperText] = useState({
		startDate: "",
		endDate: "",
	});
	const [searchValue, setSearchValue] = useState("");
	const [allTransactions, setAllTransactions] = useState([]);
	const [totalCount, setTotalCount] = useState(0);
	const [pageMaintain, setPageMaintain] = useState(0);
	const [pageNumber, setPageNumber] = useState(0);
	const [pageSize, setPageSize] = useState(12);
	const hasMore = useRef(true);

	const tagGridColumns = [
		{
			field: "date",
			headerName: "Date",
			// width: window.innerWidth < 820 ? 200 : 300,
			flex: 1,
			renderCell: (params) => {
				return (
					<div>
						<span style={{ wordBreak: "break-word", whiteSpace: "break-spaces" }}>
							{new Date(params?.row?.paymentdate).toDateString()},{" "}
							{new Date(params?.row?.paymentdate).toLocaleTimeString([], {
								hour: "2-digit",
								minute: "2-digit",
								second: "2-digit",
							})}
						</span>
					</div>
				);
			},
		},
		{
			field: "payId",
			headerName: "Pay Id",
			flex: 1,
			// width: window.innerWidth < 820 ? 160 : 220,
			renderCell: (params) => {
				return <div style={{ wordBreak: "break-word", whiteSpace: "break-spaces" }}>{params?.row?.payid}</div>;
			},
		},
		{
			field: "Amount",
			headerName: "Amount",
			flex: 1,
			// width: window.innerWidth < 820 ? 110 : 180,
			renderCell: (params) => {
				return <div>₹ {numberWithCommas(params?.row?.amount)}</div>;
			},
		},

		{
			field: "modeOfPayment",
			headerName: "Mode Of Payment",
			flex: 1,
			// width: window.innerWidth < 820 ? 190 : 280,
			renderCell: (params) => {
				return <div style={{ wordBreak: "break-word", whiteSpace: "break-spaces" }}>{params?.row?.modeofpayment}</div>;
			},
		},
		{
			field: "status",
			headerName: "Status",
			flex: 1,
			// width: window.innerWidth < 820 ? 130 : 200,
			renderCell: (params) => {
				return (
					<div>
						{params?.row?.status === "pending" && (
							<LeadStatusChip
								label={params?.row?.status}
								icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
								style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
							></LeadStatusChip>
						)}
						{params?.row?.status === "complete" && (
							<LeadStatusChip
								label={params?.row?.status}
								icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
								style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
							></LeadStatusChip>
						)}
						{(params?.row?.status === "refunded" ||
							params?.row?.status === "refund processed" ||
							params?.row?.status === "refund initiated" ||
							params?.row?.status === "adjusted") && (
							<LeadStatusChip
								label={params?.row?.status}
								icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
								style={{ color: "#E62E05", backgroundColor: "#FFF4ED" }}
							></LeadStatusChip>
						)}
					</div>
				);
			},
		},
	];

	useEffect(() => {
		let transactionInsertListner = supabase
			.from(`LeadTransactionRelations`)
			.on("INSERT", async (payload) => {
				if (payload.eventType === "INSERT" && payload.new.leadId === loggedInUser.leadId) {
					// unable to update data in table because it need full rerender so when click on next and than come back than transaction display so that's why calling the query.
					//also not add only virtual acc pay condition because payload doesn't contain modeOfPayment
					setPageMaintain(0);
					setPageNumber(0);
					getTransactionPagination(0, searchValue, filterBy.current, selectDates, false);
				}
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});

		return () => {
			if (transactionInsertListner) {
				supabase.removeSubscription(transactionInsertListner);
				transactionInsertListner = null;
			}
		};
	}, []);

	useEffect(() => {
		dispatch(actions.activeMenu("transactions"));
		getTransactionPagination(0, searchValue, filterBy.current, selectDates, false);
	}, []);

	function changeFilterBy(e) {
		setPageMaintain(0);
		setPageNumber(0);
		filterBy.current = e;
		getTransactionPagination(0, searchValue, e, selectDates, false);
	}
	useEffect(() => {
		setPageMaintain(0);
		setPageNumber(0);
		getTransactionPagination(0, searchValue, filterBy.current, selectDates, false);
	}, [filterBy, selectDates]);

	function getMoreData(passPageNumber) {
		setPageNumber(passPageNumber);
		getTransactionPagination(passPageNumber, searchValue, filterBy.current, selectDates, true);
	}

	async function getTransactionPagination(pageNumber1, searchValue, filterBy, selectDates, merge) {
		presentLoader();
		getAllTransactions(pageNumber1 * pageSize, pageNumber1 * pageSize + pageSize - 1, searchValue, filterBy, selectDates, loggedInUser?.leadId)
			.then((getTransaction) => {
				setTotalCount(getTransaction?.count);
				if (merge) {
					setAllTransactions((pre) => [...pre, ...getTransaction?.data]);
				} else {
					setAllTransactions([...getTransaction?.data]);
				}
				if (getTransaction?.data.length < 10) {
					hasMore.current = false;
				} else {
					hasMore.current = true;
				}
				dismissLoader();
			})
			.catch((err) => {
				hasMore.current = false;
				dismissLoader();

				if (err?.message) {
					errorTost(err?.message);
				} else {
					errorTost("Something went wrong! Try again");
				}
			});
	}

	const verify = useCallback(
		debounce((name) => {
			setPageMaintain(0);
			setPageNumber(0);
			getTransactionPagination(0, name, filterBy.current, selectDates, false);
		}, 500),
		[]
	);

	const handleRefreshClick = () => {
		filterBy.current = "Latest First";
		// setFilerBy("Latest First");
		setSelectDates([
			{ label: "StartDate", value: "" },
			{ label: "EndDate", value: "" },
		]);
		setPageMaintain(0);
		setPageNumber(0);
		setSearchValue("");
		getTransactionPagination(
			0,
			"",
			"Latest First",
			[
				{ label: "StartDate", value: "" },
				{ label: "EndDate", value: "" },
			],
			false
		);
	};

	function getDataForScroll() {
		getTransactionPagination(0, searchValue, filterBy.current, selectDates, true);
	}
	return (
		<div className={cssClasses.wrapperPage}>
			<div className={cssClasses.wrapperHeader}>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						width: "100%",
					}}
				>
					<div className={cssClasses.headerTitle}>{totalCount} Transactions</div>
					<div>
						<Button
							btnName={"Refresh"}
							clicked={() => {
								handleRefreshClick();
							}}
							style={{
								width: "90px",
								color: "#fff",
								backgroundColor: "rgb(21, 112, 239)",
								fontSize: "1.4rem",
								lineHeight: "2rem",
								fontFamily: "Inter-Medium !important",
							}}
						></Button>
					</div>
				</div>
			</div>
			<div className={cssClasses.contentWrapper}>
				<div className={cssClasses.filterWrapper}>
					<div className={cssClasses.filterSecData}>
						<div className={cssClasses.filterSortWrapper}>
							<div className={cssClasses.searchBar}>
								<SearchBar
									value={searchValue}
									placeholder={"Search by Pay ID or Amount"}
									search={(e) => {
										let val = e.target.value.split(",").join("").replace("₹", "").split(" ").join("");
										setSearchValue(val);
										verify(val);
									}}
									id={"transaction"}
									width="100%"
								/>
							</div>
							<div className={cssClasses.dropdownWrapper}>
								<DropDown
									placeHolder={"Sort By"}
									onChangeSelect={(e) => {
										// setFilerBy(e);
										changeFilterBy(e);
									}}
									selectedValue={filterBy.current}
									style={{ selectedColor: "#175CD3", background: "#fff" }}
									list={["Oldest First", "Latest First"]}
								/>
							</div>
						</div>
					</div>
					<div className={cssClasses.dateFilterWrapper}>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "0.5rem",
							}}
						>
							<DateComponent
								minDate={new Date("01/01/2023")}
								maxDate={selectDates[1]?.value !== "" ? new Date(selectDates[1]?.value) : new Date()}
								value={selectDates[0].value}
								helperText={helperText?.startDate}
								onChangeDate={(value) => {
									setSelectDates((pre) => {
										pre[0].value = value;
										return { ...pre };
									});
									setHelperText((pre) => {
										pre.endDate = "";
										return { ...pre };
									});
								}}
							/>
						</div>
						<span className={cssClasses.dateText}>to</span>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "0.5rem",
							}}
						>
							<DateComponent
								minDate={new Date(selectDates[0]?.value)}
								maxDate={new Date()}
								disabled={selectDates[0]?.value === ""}
								value={selectDates[1].value}
								helperText={helperText?.endDate}
								onChangeDate={(value) => {
									if (selectDates[0].value === "") {
										setHelperText((pre) => {
											pre.endDate = "Please select start date first";
											return { ...pre };
										});
									} else {
										if (selectDates[0].value > value) {
											setHelperText((pre) => {
												pre.endDate = "Select End Date Greater than start Date";
												return { ...pre };
											});
											setSelectDates((pre) => {
												pre[1].value = "";
												return { ...pre };
											});
										} else {
											setSelectDates((pre) => {
												pre[1].value = value;
												return { ...pre };
											});
											setHelperText((pre) => {
												pre.endDate = "";
												return { ...pre };
											});
											setIsEndDateNotNull(true);
										}
									}
								}}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className={cssClasses.tableWrapper}>
				{allTransactions?.length > 0 ? (
					<DataGrid
						className={cssClasses.tableWrapperGrid}
						rows={allTransactions}
						columns={tagGridColumns}
						pageSize={10}
						rowsPerPageOptions={[10]}
						page={pageMaintain}
						onPageChange={(_page) => {
							setPageMaintain(_page);
							if (pageNumber < _page) {
								getMoreData(_page);
							}
						}}
						sx={[dataGridStyles]}
					/>
				) : (
					<div className={cssClasses.noDataWrapper}>
						<div className={cssClasses.noDataMsg}>
							<div className={cssClasses.emptyIcon}>
								<img src={EmptyState} alt="No Data" />
							</div>
							<div className={cssClasses.emptyTitle}>No Transactions Available</div>
						</div>
					</div>
				)}
			</div>
			<div className={cssClasses.mobileTableWrapper}>
				<div className={cssClasses.transactionTableWrapper} id="scrollableDiv">
					{allTransactions?.length > 0 && (
						<InfiniteScroll
							dataLength={allTransactions?.length}
							next={() => {
								if (hasMore.current) {
									getDataForScroll();
								}
							}}
							style={{
								display: "flex",
								flexDirection: "column",
								overflowY: "auto",
								gap: "1.4rem",
							}} //To put endMessage and loader to the top.
							hasMore={hasMore.current}
							scrollableTarget="scrollableDiv"
						>
							{allTransactions.map((transaction, i) => (
								<Card className={cssClasses.cardWrap} key={i}>
									<div className={cssClasses.cardWrapHeader}>
										<div>
											{/* <div className="label">PayId</div> */}
											<div className={cssClasses.payIDContent}>
												<span>{transaction?.payid}</span>
											</div>
										</div>
										<div className={cssClasses.StatusContent}>
											{transaction.status === "pending" && (
												<LeadStatusChip
													label={transaction.status}
													icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
													style={{
														color: "#B42318",
														backgroundColor: "#FEF3F2",
														fontSize: "1.8rem",
														padding: "0.8rem",
													}}
												></LeadStatusChip>
											)}
											{transaction.status === "complete" && (
												<LeadStatusChip
													label={transaction?.status}
													icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
													style={{
														color: "#027A48",
														backgroundColor: "#ECFDF3",
														fontSize: "1.8rem",
														padding: "0.8rem",
													}}
												></LeadStatusChip>
											)}
											{(transaction?.status === "refunded" ||
												transaction?.status === "refund processed" ||
												transaction?.status === "refund initiated" ||
												transaction?.status === "adjusted") && (
												<LeadStatusChip
													label={transaction?.status}
													icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
													style={{ color: "#E62E05", backgroundColor: "#FFF4ED", fontSize: "1.8rem" }}
												></LeadStatusChip>
											)}
										</div>
									</div>
									<div className={cssClasses.cardWrapHeader}>
										{/* <div className="label">Mode Of Payment</div> */}
										<div className="content">
											<span>{transaction?.modeofpayment}</span>
										</div>
										{/* <div className="label">Date</div> */}
										<div className="content">
											<span>
												{new Date(transaction?.paymentdate).toDateString()},{" "}
												{new Date(transaction?.paymentdate).toLocaleTimeString([], {
													hour: "2-digit",
													minute: "2-digit",
													second: "2-digit",
												})}
											</span>
										</div>
									</div>

									<div className={cssClasses.cardPaidAmtWrap}>
										{/* <div className="label">Amount</div> */}
										<div className="content">
											<div className={cssClasses.tokenTotalAmount}>
												<div className={cssClasses.paidAmt}>
													<div className={cssClasses.paidAmtLable}>PAID AMOUNT </div>
													<div className={cssClasses.tokenAmtPaid}>₹ {numberWithCommas(transaction?.amount)}</div>
												</div>
											</div>
										</div>
									</div>
								</Card>
							))}
						</InfiniteScroll>
					)}
					{allTransactions?.length === 0 && (
						<div className={cssClasses.noDataWrapper}>
							<div className={cssClasses.noDataMsg}>
								<div className={cssClasses.emptyIcon}>
									<img src={EmptyState} alt="No Data" />
								</div>
								<div className={cssClasses.emptyTitle}>No Transactions Available</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Transactions;
